import { render, staticRenderFns } from "./MarketingAutomationFormPanelEmail.vue?vue&type=template&id=e94d38e0&scoped=true"
import script from "./MarketingAutomationFormPanelEmail.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormPanelEmail.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationFormPanelEmail.vue?vue&type=style&index=0&id=e94d38e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94d38e0",
  null
  
)

export default component.exports